export const template = {
  name: 'Naam',
  templateAsylumCenter: 'Template centrum',
  templateResidence: 'Template woningen',
  editTemplate: 'Template aanpassen',
  template: 'Template',
  addTemplate: 'Template toevoegen',
};
